import React, { useState } from 'react'
import { FetchResult, useMutation } from '@apollo/client'
import { Dropdown, Button, MenuProps, message } from 'antd'
import styled from 'styled-components'
import { LEGAL_FORMALITIES_EXPORT_COMPLETIONS_MUTATION } from 'graphql/LegalFormalitiesExports'
type MenuItem = Required<MenuProps>['items'][number]

interface IFormalitiesMenu {
  tableLoading: boolean
}
interface IActionResult {
  legalFormalitiesExportCompletions: {
    message: string
  }
}

const Formalities = (props: IFormalitiesMenu): JSX.Element => {
  const [loading, setLoading] = useState(false)
  const [legalFormalitiesExportCompletions] = useMutation(
    LEGAL_FORMALITIES_EXPORT_COMPLETIONS_MUTATION
  )
  const [messageApi, contextHolder] = message.useMessage()

  const displayError = (message: string) => {
    messageApi.open({
      type: 'error',
      content: message,
    })
  }
  const displayMessage = (message: string) => {
    messageApi.open({
      type: 'success',
      content: message,
      duration: 3,
    })
  }

  const sendFormalitiesManagementQuery = (key: string) => {
    setLoading(true)
    legalFormalitiesExportCompletions()
      .then(res => {
        const data = res.data
        setLoading(false)
        if ('legalFormalitiesExportCompletions' in data) {
          displayMessage(data.legalFormalitiesExportCompletions.message)
        }
      })
      .catch(response => {
        setLoading(false)
        displayError(response.message)
      })
  }

  const items: MenuItem[] = [
    {
      key: 'sub1',
      icon: <i className={'fa fa-file'}></i>,
      label: 'Exports',
      children: [
        {
          key: '1',
          label: 'Relances Complétions',
          onClick: () => {
            sendFormalitiesManagementQuery('export_completions')
          },
        },
      ],
    },
  ]

  return (
    <FormalitiesMenu>
      {contextHolder}
      <Dropdown menu={{ items }}>
        <MenuButton>
          {loading ? (
            <i className={'fa fa-spinner'} />
          ) : (
            <i className={'fa fa-cogs'} />
          )}
        </MenuButton>
      </Dropdown>
    </FormalitiesMenu>
  )
}

export default Formalities

const MenuButton = styled(Button)`
  height: fit-content;
  background: white;
  color: rgba(0, 0, 0, 0.45);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02);
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 4px 10px;
  i {
    padding: 10px 0;
    margin: 0;
  }
`
const FormalitiesMenu = styled.div`
  padding: 20px 0px 8px;
  display: flex;
  justify-content: stretch;
`
